export enum CustomerStatuses {
	New = 'New',
	Engaged = 'Engaged',
	Invoiced = 'Invoiced',
	Standard = 'Standard',
	Dead = 'Dead',
	Trial = 'Trial',
}
